import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    scrollMarginTop: '1rem'
  },

  glowRoot: {
    animation: '$glow 0.5s linear infinite alternate'
  },

  '@keyframes glow': {
    '0%': {
      boxShadow: `0 4px 10px 0 ${theme.palette.primary.main}`
    },

    '100%': {
      backgroundColor: `0 4px 10px 0 ${theme.palette.secondary.main}`
    }
  }
}))

export default useStyles
